import React, { useContext, useState } from 'react';
import { TriggerContext } from '../../../../../..';
import { Tooltip, HelpIcon, Radio, RadioGroup, Input, Field, FieldStatus } from '@m/alchemy-ui';
import { StyledDurationHeader, StyledDurationRadio, StyledWcagWarning, StyledTargetingRadioWithWarning } from './StyledDuration';
import { PanelSubHeader, Subtitle } from '../../../../../../StyledTriggeringModal';
import { getSingleText } from '../../../../../../../../../common/utils';
import { TargetingActions } from '../../../../Actions';
import { TextPathPrefix } from '../../../..';
import { getNestedProperty } from '@mdigital/common/dist/utils/object';

const ACCESSIBILITY_MINIMUM_DURATION_S = 20;

const RadioItem = {
  ALWAYS : 'Always',
  DISAPPEAR_AFTER: 'Disappear after',
};

const Duration = () => {
  const durationRadioItems = [RadioItem.DISAPPEAR_AFTER, RadioItem.ALWAYS];
  const { triggerState , triggerDispatch, isReadOnly } = useContext(TriggerContext);
  const isSticky = getNestedProperty(triggerState , 'trigger.triggerCustomBannerContract.isSticky');
  const selection = isSticky ? durationRadioItems[1] : durationRadioItems[0];

  const formatTimeValue = (time) => {
    return time / 1000;
  };
  const valueFromStore = formatTimeValue(getNestedProperty(triggerState, 'trigger.triggerCustomBannerContract.invitationTimeout'));
  const isBelowAccessibilityThreshold = (seconds) =>
    seconds < ACCESSIBILITY_MINIMUM_DURATION_S;
  const [isBelowThreshold, setIsBelowThreshold] = useState(() =>
    isBelowAccessibilityThreshold(valueFromStore)
  );

  const handleDisappearAfterChange = (e) => {
    triggerDispatch({ type : TargetingActions.SET_BANNER_INVITATION_TIMEOUT , payload : e.target.value });
    setIsBelowThreshold(isBelowAccessibilityThreshold(e.target.value));
  };

  return (
    <React.Fragment>
      <StyledDurationHeader>
        <PanelSubHeader>{getSingleText(`${TextPathPrefix}.durationHeader`)}</PanelSubHeader>
        <Tooltip
          trigger={
            <HelpIcon aria-label="Information Icon" size="12" palette="structural" />
          }
          placement="right"
          contents={getSingleText(`${TextPathPrefix}.durationTooltip`)}
        />
      </StyledDurationHeader>
      <RadioGroup selection={selection}
        onChange={ ()=> triggerDispatch({ type : TargetingActions.SET_IS_BANNER_STICKY , payload : !isSticky })}
        style={{ paddingBottom: isBelowThreshold ? '28px' : '56px' }}
      >
        {({ isSelected, handleChange }) =>
          durationRadioItems.map((item, index) => (
            <StyledTargetingRadioWithWarning key={index}>
              <StyledDurationRadio>
                <Radio
                  key={item}
                  label={item}
                  disabled={isReadOnly}
                  checked={isSelected(item)}
                  onChange={() => handleChange(item)}
                />
                {item === RadioItem.DISAPPEAR_AFTER  &&
                  <React.Fragment>
                    <Field
                      {...(isBelowThreshold ? { status: { level: 'error' } } : {})}
                      input={<Input type="number" min='1' max='60'
                        disabled={getNestedProperty(triggerState , 'trigger.triggerCustomBannerContract.isSticky') || isReadOnly}
                        value={valueFromStore}
                        onChange={handleDisappearAfterChange}
                        className={isBelowThreshold ? 'warning' : ''}
                      />}
                    />
                    <Subtitle fontColor="typeBody">{getSingleText(`${TextPathPrefix}.sec`)}</Subtitle>
                  </React.Fragment>
                }
              </StyledDurationRadio>
              {item === RadioItem.DISAPPEAR_AFTER  && isBelowThreshold &&
                <StyledWcagWarning>
                  <FieldStatus
                    type="warning"
                    message={getSingleText(`${TextPathPrefix}.WcagWarning`)}
                  />
                </StyledWcagWarning>
              }
            </StyledTargetingRadioWithWarning>
          ))
        }
      </RadioGroup>
    </React.Fragment>
  );
};

export default Duration;